import './index.less';

import PropTypes from 'prop-types';
import React from 'react';
import CountUp from 'react-countup';
import handleViewport from 'react-in-viewport';

const CounterUSP = ({ value = 0, suffix, title, body, innerRef, inViewport }) => (
  <div className="counter" ref={innerRef}>
    {inViewport ? (
      <>
        {/* <CountUp start={value} end={value} duration={0.1} formattingFn={suffix ? (value) => value + suffix : null} /> */}
        <span>{value}</span>
        <h3>{title}</h3>

        <p dangerouslySetInnerHTML={{ __html: body }} />
      </>
    ) : (
      <>
        <CountUp start={0} end={0} />
        <h3>{title}</h3>

        <p dangerouslySetInnerHTML={{ __html: body }} />
      </>
    )}
  </div>
);

CounterUSP.propTypes = {
  value: PropTypes.number,
  title: PropTypes.string,
  body: PropTypes.string,
};

export default handleViewport(CounterUSP);
